"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalJobUpload = void 0;
var react_1 = __importDefault(require("react"));
var structure_1 = require("remota-client/component/structure");
var form_1 = require("./form");
var ExternalJobUpload = function (props) {
    var _a = __read(props.useLoadExternalJob(props.jobId), 2), job = _a[0], status = _a[1];
    return (react_1.default.createElement(structure_1.PlainStructure, { center: true }, job ? (react_1.default.createElement(form_1.Form, { job: job, useVoucherExternalUpload: props.useVoucherExternalUpload, useJobRun: props.useJobRun })) : status.error ? ("対象の取込元が見つかりません。問題がないか設定担当者にご確認ください。") : null));
};
exports.ExternalJobUpload = ExternalJobUpload;
